/* src/composables/useBetSlip.js */
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export function useBetSlip() {
  const route = useRoute()
  const showBetSlip = computed(() => {
    // Opt-in via meta, plus a safe fallback for the Home route by name.
    const optedIn = route.matched.some(r => r.meta && r.meta.showBetSlip === true)
    const isHome  = route.name === 'home'
    return optedIn || isHome
  })
  return { showBetSlip }
}
